export default function HeroSection() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1ff2a522f99463f1ace4cfe96504da2f.jpg"
          alt="ACBuy Spreadsheet 2026 - Best Replica Shopping Resource"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-20">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 bg-amber-400 rounded-full animate-pulse"></span>
          <span className="text-amber-300 text-sm font-medium">Updated Daily — 100,000+ Products</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          The Complete<br />
          <span className="text-amber-400">ACBuy Spreadsheet</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto mb-4 leading-relaxed">
          Your #1 resource for <strong>acbuy spreadsheet 2026</strong> — find the best replica products, QC photos, hipobuy spreadsheet alternatives, and shipping deals all in one place.
        </p>
        <p className="text-sm md:text-base text-gray-300 max-w-xl mx-auto mb-10">
          Trusted by thousands of buyers. Better than hipobuy spreadsheet 2026. Free to use, updated daily.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://repsw2c.com/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white font-bold text-base rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-file-list-3-line mr-2"></i>
            acbuy2026spreadsheet shipping
          </a>
          <a
            href="https://repsw2c.com/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-8 py-4 bg-white hover:bg-gray-100 text-gray-900 font-bold text-base rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            Buy It Now
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: "ri-shield-check-line", label: "Verified Sellers" },
            { icon: "ri-camera-line", label: "QC Photos" },
            { icon: "ri-truck-line", label: "Shipping Deals" },
            { icon: "ri-group-line", label: "50K+ Community" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-gray-300">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-amber-400`}></i>
              </div>
              <span className="text-sm font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </div>
      </div>
    </section>
  );
}
